<template>
  <div class="case-page">
    <div class="nav-list">
      <div
        class="nav-item"
        :class="{ 'nav-item-active': active == index }"
        v-for="(item, index) in navData"
        :key="index"
        @click="bindClick(index)"
        >{{ item.title }}</div
      >
    </div>
    <div class="wrapper">
      <div
        class="wrapper-scroll"
        v-for="(item, index) in navData"
        :key="index"
        v-show="active == index"
      >
        <div class="image-list">
          <img
            class="image-item"
            :src="item1"
            alt=""
            v-for="(item1, index1) in item.images"
            :key="index1"
          />
        </div>
      </div>
    </div>
    <div class="bottom">
      <img
        class="bottom-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dd0ff41df855e4b977fa484078607146.png"
        alt=""
      />
      <div class="consult-btn" @click="bindConsult"> </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      active: 0,
      navData: [
        {
          title: '歌手何洁',
          images: [
            'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/e746200e76f6d9ad9a44bb2a24e3dd21_wh=1125_3684.png',
            'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/aee00654cb11f79c6e727ba5e5a18efc_wh=1125_3132.png',
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9f1069b734aebdc81feabe7062115076.png',
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6ce7058b04b0e0d379538b76c3ccfe8.png'
          ]
        },
        {
          title: '歌手江映蓉',
          images: [
            'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/477582389f9c8c68f5e839ee03ffacb1_wh=1125_3684.png',
            'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/fa1d171eb5344809de1a62a076a8aa03_wh=1125_3258.png',
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1e0303ae8bff78a75643b0b36b4b5cfb.png',
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9d5fba7326319fdac4381d62879010e0.png'
          ]
        },
        {
          title: '主持人杜海涛',
          images: [
            'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/923e4ea74cb375a74b086ac85255f18a_wh=1125_3684.png',
            'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/f739c7e2cd8bbcc829697c7dcd50df5c_wh=1125_4167.png',
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2db795a6fdedbbbb8b511a7c3d8a74a2.png',
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2b31913e2af794b2844af0dc57ec55a4.png'
          ]
        }
      ]
    }
  },
  created() {
    let tab = +this.$route?.query.tab
    if (tab) {
      this.active = tab - 1 < 0 ? 0 : tab - 1
    }
  },
  methods: {
    bindClick(index) {
      this.active = index
    },
    bindConsult() {
      location.href =
        'https://work.weixin.qq.com/ca/cawcdefad2ede434f7?customer_channel=qywx_ca:107597883'
    }
  }
}
</script>
<style lang="scss" scoped>
.case-page {
}

.bottom {
  position: fixed;
  z-index: 1;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #fff;
  @include paddingBottom(0px);

  .bottom-image {
    width: 100%;
  }

  .consult-btn {
    width: 343px;
    height: 52px;
    position: absolute;
    left: 50%;
    bottom: 8px;
    transform: translate(-50%, 0%);
  }
}

.nav-list {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  height: 45px;

  .nav-item {
    position: relative;
    flex: 1;
    text-align: center;
    font-size: 14px;
    font-family: MiSans, MiSans;
    color: rgba(0, 0, 0, 0.7);
    line-height: 16px;
    transition: 0.2s all ease;
  }

  .nav-item::after {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-50%, -50%);
    content: '';
    width: 1px;
    height: 13px;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .nav-item:last-child::after {
    display: none;
  }

  .nav-item-active {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }
}

.wrapper {
  height: 100vh;

  .wrapper-scroll {
    height: 100%;
    overflow-y: scroll;

    .image-list {
      @include paddingBottom(30px);

      .image-item {
        width: 100%;
      }
    }
  }
}
</style>
